<template>
  <footer class="dev-footer">
    <div class="content has-text-centered">
      <p>
        <strong>ShapeLog®</strong> is a registered trademark. Copyright 2016-18 ShapeLog, Inc.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'view-footer',
};
</script>

<style scoped lang="scss">
  @import '@/styles/common.scss';

  .dev-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: $shapelog-black;
    padding: 0.5rem;
    color: $shapelog-dark-gray;

    strong {
      color: $shapelog-dark-gray;
    }

    a {
      color: $shapelog-dark-gray;
    }
  }
</style>
